
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-blog-detail',
  templateUrl: './blog-detail.component.html',
  styleUrls: ['./blog-detail.component.css']
})
export class BlogDetailComponent {
  blogData: any;
  id:any;
  BaseUrl: any;
  taxInfo: any;
  constructor(private userService: UserService,private route: ActivatedRoute) { }
 ngOnInit() {
     this.route.paramMap.subscribe(params => {
    this.id = params.get('id') || '';
    console.log('Blog ID:', this.id);
  });
this.fetchBlogData();
this.BaseUrl=environment.userApiUrl + 'slider/';
this.marketPrice();
}
fetchBlogData(){
this.userService.fetchBlogDataById(this.id).subscribe({
  next: (data:any) => {
    this.blogData=data?.data;
    console.log("Blog data fetched successfully:", this.blogData);
    this.taxInfo=this.blogData?.blogDetail;
  }
  , error: (error) => {
    console.error("Error fetching blog data:", error);
  }
});}
marketPrice(){
}
}
